import React from 'react';
import { useQuery } from '@apollo/client/react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Avatar, Box, Typography } from '@mui/material';
import { MY_TRAINER_SUBSCRIPTION_QUERY } from '../../../graphql/trainer_subscription';
import Loading from '../../../components/shared/Loading';

const YourPlanBox = ({ user }) => {
  const { loading, error, data } = useQuery(MY_TRAINER_SUBSCRIPTION_QUERY);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <></>;
  }

  return (
    <Box p={2}>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.default',
          borderRadius: 1,
          display: 'flex',
          overflow: 'hidden',
          p: 2,
        }}
      >
        <RouterLink to="/trainer/account">
          <Avatar
            src={user.photoURL}
            sx={{
              cursor: 'pointer',
              height: 48,
              width: 48,
            }}
          />
        </RouterLink>
        <Box ml={2}>
          <Typography color="textPrimary" variant="subtitle2">
            {user.displayName || user.email}
          </Typography>
          <Typography color="textSecondary" variant="body2">
            <Link
              color="primary"
              component={RouterLink}
              to="/trainer/account/subscription"
            >
              Your Plan:{' '}
              {data.myTrainerSubscription?.status ||
                'Free, Upgrade to Publish your App'}
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default YourPlanBox;
